import React from "react";
import { useLocation, Link } from "react-router-dom";
import useProducts from "../../hooks/useProducts";
import styles from "./Products.module.css";

const Products = ({ showTitle = true }) => {
    const location = useLocation();
    const isHomePage = location.pathname === "/";
    const { products, blurProducts, loading, error } = useProducts("Luminis"); 
    
    if (loading) {
        return <h2>Loading products...</h2>;
    }

    if (error) {
        return <h2>Error: {error}</h2>;
    }
    
    const sortedProducts = [...products].sort((a, b) => a.product_order - b.product_order);
    const sortedBlurProducts = [...blurProducts].sort((a, b) => a.product_order - b.product_order);

    const content = (
        <section id="products" className={`${styles.productsSection} ${isHomePage ? styles.noMargin : ""}`}>
            {showTitle && (
                <div className={styles.sectionHeader}>
                    <h2 className={styles.productsTitle}>Топ подаръци</h2>
                    <p className={styles.sectionSubtitle}>Най-желаните ни продукти</p>
                </div>
            )}

            <div className={styles.grid}>
                {sortedProducts.map(product => {
                    const primaryImage = product.images.find(image => image.is_primary)?.image_url || "/images/placeholder.png";
                    return(
                        <Link to={`/product/${product.id}`} key={product.id} className={styles.productLink}>
                            <div className={styles.productCard}>
                                <div className={styles.imageWrap}>
                                    <img src={primaryImage} alt={product.name} className={styles.productImage} />
                                </div>
                                <div className={styles.cardBody}>
                                    <h3>{product.productname}</h3>
                                    <div className={styles.priceRow}>
                                        <span className={styles.price}>{product.discount_price}€</span>
                                        <span className={styles.secondaryPrice}>{parseFloat((product.discount_price * 1.9558).toFixed(2))}лв.</span>
                                    </div>
                                </div>
                                <div className={styles.cardFooter}>
                                    <span className={styles.footerCta}>Виж детайли</span>
                                </div>
                            </div>
                        </Link>
                    );
                })}

                {sortedBlurProducts.map(product => {
                    const primaryImage = product.images.find(image => image.is_primary)?.image_url || "/images/placeholder.png";
                    return(
                        <Link to={`/notavl`} key={product.id} className={styles.productLink}>
                            <div className={`${styles.productCard} ${styles.productCardBlur}`}>
                                <div className={styles.imageWrap}>
                                    <img src={primaryImage} alt={product.name} className={styles.productImageBlur} />
                                    <span className={styles.badge}>Изчерпан</span>
                                </div>
                                <div className={styles.cardBody}>
                                    <h3>{product.productname}</h3>
                                    <p className={styles.secondaryPrice}>??.?? €</p> 
                                    <p className={styles.newPrice}>Няма наличност</p> 
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );

    return isHomePage ? content : <div className={styles.page}>{content}</div>;
};

export default Products;
